'use client';
import React from 'react';
import { CmsClientContext } from './CmsClientContext';
import { CmsClientProviderProps } from './types';

export const CmsClientProvider: React.FC<CmsClientProviderProps> = ({
  children,
  value,
}) => {
  return (
    <CmsClientContext.Provider value={value}>
      {children}
    </CmsClientContext.Provider>
  );
};
